/**
 * Subscription Access Check for Child App
 * Shows a friendly disabled message when the family has no active subscription.
 * NEVER shows payment info, amounts, or "subscribe" text.
 * Requirements: 9.1-9.6
 */

import { t } from '../i18n/config.js';

/**
 * Check if the content response indicates active access.
 * @param {Object} contentResponse - API response that may include hasActiveAccess
 * @returns {boolean} true if access is active or field is missing (backward compat)
 */
export function hasActiveAccess(contentResponse) {
  // If the field isn't present, assume access (backward compatibility)
  if (contentResponse && contentResponse.hasActiveAccess === false) {
    return false;
  }
  return true;
}

/**
 * Render the friendly disabled message when access is not active.
 * Age-appropriate, no payment info, visually appealing.
 * @param {HTMLElement} container - Container to render into
 */
export function renderAccessDisabled(container) {
  container.innerHTML = `
    <div class="access-disabled-screen">
      <img src="/svg/branding/KassieAvatar.svg" alt="Kassie" width="150" />
      <h1>${t('child.access.askParent') || 'Vra vir Mamma of Pappa om te help'}</h1>
      <p>${t('child.access.message') || 'Ons het hulp nodig om voort te gaan.'}</p>
      <div class="access-disabled-decoration">
        <img src="/svg/components/YellowStar.svg" alt="" width="40" />
        <img src="/svg/components/YellowStar.svg" alt="" width="30" />
        <img src="/svg/components/YellowStar.svg" alt="" width="40" />
      </div>
    </div>
  `;
}
